import Environment from "./Environment";

// Token configuration with addresses and special behavior flags
// Decimals are fetched dynamically from the token contract
export const TOKEN_CONFIG = {
  ETH: {
    symbol: "ETH",
    needsApproval: false,
  },
  WETH: {
    symbol: "WETH",
    address: Environment.weth,
    needsApproval: true,
    requiresResetApproval: true, // Special case: USDT requires resetting allowance to 0 before increasing
  },
  USDT: {
    symbol: "USDT",
    address: Environment.busd,
    needsApproval: true,
    requiresResetApproval: true, // Special case: USDT requires resetting allowance to 0 before increasing
  },
  USDC: {
    symbol: "USDC",
    address: Environment.usdc, // Add this to your Environment
    needsApproval: true,
  },
  WBTC: {
    symbol: "WBTC",
    address: Environment.wbtc, // Add this to your Environment (8 decimals)
    needsApproval: true,
  },
  LINK: {
    symbol: "LINK",
    address: Environment.link, // Add this to your Environment
    needsApproval: true,
  },
  PEPE: {
    symbol: "PEPE",
    address: Environment.pepe, // Add this to your Environment
    needsApproval: true,
  },
  DOP: {
    symbol: "DOP",
    address: Environment.dop, // Add this to your Environment
    needsApproval: true,
  },
  UNI: {
    symbol: "UNI",
    address: Environment.uni, // Add this to your Environment
    needsApproval: true,
  },
  TOMI: {
    symbol: "TOMI",
    address: Environment.tomi, // Add this to your Environment
    needsApproval: true,
  },
  GEMS: {
    symbol: "GEMS",
    address: Environment.gems, // Add this to your Environment
    needsApproval: true,
  },
};

// Helper function to get token config
export const getTokenConfig = (tokenSymbol) => {
  const config = TOKEN_CONFIG[tokenSymbol];
  if (!config) {
    throw new Error(`Token ${tokenSymbol} not configured`);
  }
  return config;
};
